var n = /* @__PURE__ */ ((r) => (r.Error = "error", r.Warning = "warning", r.Info = "info", r.Success = "success", r))(n || {}), c = /* @__PURE__ */ ((r) => (r.Error = "red-500", r.Warning = "orange-500", r.Info = "blue-500", r.Success = "green-500", r))(c || {}), e = /* @__PURE__ */ ((r) => (r.Error = "hazard", r.Warning = "circle-warning", r.Info = "circle-info", r.Success = "circle-check", r))(e || {});
export {
  e as S,
  c as a,
  n as b
};
//# sourceMappingURL=statusLevels-D8EgtE_L.js.map
